import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Mail, ShieldCheck } from "lucide-react";
import { Switch } from "./ui/switch";
import api from "../lib/api";

const OPTIONAL = [
  ["streak_reminders", "Study streak reminders", "One email on a day your 3+ day streak is about to break (never more than one a day)."],
  ["study_reminders", "Study reminders", "A nudge after 5+ days away — at most once a week."],
  ["weekly_summary", "Weekly progress summary", "Monday recap of questions, accuracy, boards and streak — only when you were active."],
  ["product_updates", "Product updates", "Occasional notes about meaningful new features. Never for minor fixes."],
  ["hiring_alerts", "Department hiring alerts", "Coming later: verified hiring announcements for departments you follow or favorite (from official sources only)."],
];
const TIMEZONES = ["America/New_York", "America/Chicago", "America/Denver", "America/Phoenix", "America/Los_Angeles", "America/Anchorage", "Pacific/Honolulu", "America/Puerto_Rico"];

export function EmailPreferences() {
  const [p, setP] = useState(null); const [account, setAccount] = useState([]);
  useEffect(() => { api.get("/me/email-prefs").then(({ data }) => { setP(data.prefs); setAccount(data.account_emails); }).catch(() => {}); }, []);
  const save = async (patch) => {
    const prev = p; setP({ ...p, ...patch });
    try { const { data } = await api.put("/me/email-prefs", patch); setP(data.prefs); toast.success("Email preferences saved."); } catch { setP(prev); toast.error("Could not save."); }
  };
  if (!p) return null;
  return (
    <div id="email" className="bg-white border border-slate-200 rounded-2xl p-6" data-testid="email-preferences">
      <p className="text-[11px] font-bold uppercase tracking-wider text-slate-400 flex items-center gap-1.5"><Mail className="w-3.5 h-3.5 text-primary" /> Email preferences</p>
      <p className="text-sm text-slate-600 mt-1">Optional emails you can turn on or off any time. We keep it light — no daily blasts.</p>
      <ul className="mt-4 divide-y divide-slate-100">
        {OPTIONAL.map(([k, l, d]) => (
          <li key={k} className="flex items-start justify-between gap-4 py-3" data-testid={`email-pref-row-${k}`}>
            <div><p className="text-sm font-semibold text-slate-900">{l}</p><p className="text-xs text-slate-500 mt-0.5">{d}</p></div>
            <Switch checked={!!p[k]} disabled={k === "hiring_alerts"} onCheckedChange={(v) => save({ [k]: v })} data-testid={`email-pref-${k}`} />
          </li>
        ))}
      </ul>
      <div className="mt-3 flex items-center justify-between gap-4 pt-3 border-t border-slate-100">
        <div><p className="text-sm font-semibold text-slate-900">Reminder time zone</p><p className="text-xs text-slate-500">Reminders go out around 5 pm local; the weekly summary Monday morning.</p></div>
        <select value={p.timezone} onChange={(e) => save({ timezone: e.target.value })} className="text-sm border border-slate-200 rounded-md px-2 py-1.5 bg-white" data-testid="email-pref-timezone">{TIMEZONES.map((z) => <option key={z} value={z}>{z.replace("America/", "").replace("Pacific/", "").replace("_", " ")}</option>)}</select>
      </div>
      <div className="mt-4 rounded-xl bg-slate-50 border border-slate-200 p-3" data-testid="email-account-category">
        <p className="text-xs font-semibold text-slate-700 inline-flex items-center gap-1.5"><ShieldCheck className="w-3.5 h-3.5 text-emerald-600" /> Account emails (always on)</p>
        <p className="text-xs text-slate-500 mt-1">{account.join(" · ")}. These are sent only when something happens on your account.</p>
      </div>
    </div>
  );
}
